import { AsyncPipe, CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { TabsetComponent } from "ngx-bootstrap/tabs";
import { Observable } from "rxjs";
import { filter, map, mergeMap } from "rxjs/operators";
import { LearningObjectiveInfoWithVideoState } from "../shared/model/model";
import { SharedModule } from "../shared/shared.module";
import {
  LearningObjectiveInfoState,
  LoadLearningObjectiveInfoAction,
} from "../shared/store/learning-objective-info.state";
import { SelectLearningobjectiveAction } from "../shared/store/learning-objectives.state";
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-learning-objective-info",
  templateUrl: "learning-objective-info.component.html",
  styleUrls: ["learning-objective-info.component.scss"],
  standalone: true,
  imports: [SharedModule, CommonModule, AsyncPipe],
})
export class LearningObjectiveInfoComponent {
  public learningObjectiveInfoState$: Observable<LearningObjectiveInfoWithVideoState>;

  @HostBinding("class.shadow-lg") shadow = true;

  @ViewChild("tabset", { static: true }) tabset: TabsetComponent;
  @ViewChild("audio", { static: true }) playerRef: ElementRef<HTMLAudioElement>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private domSanitizer: DomSanitizer
  ) {
    this.learningObjectiveInfoState$ = this.route.params.pipe(
      mergeMap((params: Params) => {
        const code = <string>params["code"];
        if (this.tabset) {
          this.tabset.tabs[0].active = true;
        }
        this.store.dispatch(new LoadLearningObjectiveInfoAction(code));
        return this.store.select(LearningObjectiveInfoState.info).pipe(
          filter((s) => !!s),
          map((s) => {
            this.store.dispatch(
              new SelectLearningobjectiveAction(s.learningObjective)
            );

            //reload audio element if needed.
            if (s.learningObjective.childLanguageAudio && this.playerRef) {
              this.playerRef.nativeElement.load();
            }

            return {
              ...s,
              videoMp4: s.instructionVideo
                ? this.domSanitizer.bypassSecurityTrustUrl(
                    `${s.instructionVideo}&type=mp4`
                  )
                : "",
              videoWebm: s.instructionVideo
                ? this.domSanitizer.bypassSecurityTrustUrl(
                    `${s.instructionVideo}&type=webm`
                  )
                : "",
            };
          })
        );
      })
    );
  }
  close = () =>
    this.router.navigate(["../../"], {
      queryParams: this.route.snapshot.queryParams,
      relativeTo: this.route,
    });
}
